<template lang="pug">
//- 项目内审批
#approvalContainer
  .approval
    el-tabs(v-model="activeName" )
      el-tab-pane(label="全部流程" name="4" v-if="allFlowPerm")
      el-tab-pane(label="我的创建" name="3")
      el-tab-pane(label="我的审批" name="2")
      el-tab-pane(label="新建流程" name="1")
    .list
      newApproval(ref="newApproval" isProject  v-if="activeName==='1'")
      myApplication(ref="myApplication" isProject  v-if="activeName==='2'")
      myCreate(ref="myCreate" isProject  v-if="activeName==='3'")
      allFlow(ref="allFlow" isProject  v-if="activeName==='4' && allFlowPerm")
</template>

<script>
import newApproval from "@/CommonDP/pages/mainMg/approval/components/newApproval.vue";
import myApplication from "./myApplication.vue";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
import myCreate from "./myCreate.vue";
import allFlow from './allFlow.vue'
export default {
  components: { newApproval, myApplication, myCreate, allFlow },
  data () {
    return {
      activeName: "4",
      allFlowPerm: checkPermission(':approval:all'),
    };
  },
  created() {
    this.activeName = this.allFlowPerm ? "4" : "3"
  }
};
</script>

<style lang="scss" scoped>
#approvalContainer {
  width: 100%;
  height: 100%;
}
.approval{
  width: 100%;
  height: 100%;
  border-radius: 4px;
  // background-color: #fff;
  .el-tabs{
    padding: 0 var(--big-space);
    background-color: #fff;
    border-radius: 5px 5px 0 0;
    /deep/.el-tabs__header{
      margin-bottom: 0 !important;
    }
    /deep/.el-tabs__item{
      height: 50px;
      line-height: 50px;
    }
  }
  .list{
    width: 100%;
    height: calc(100% - 50px);
  }
}
</style>
